import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  workflowDictionaryAll: [],
  workflowDictionary: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const workflowDictionarySlice = createSlice({
  name: "workflowDictionary",
  initialState,
  reducers: {
    setWorkflowDictionaryAll: (state, action) => {
      state.workflowDictionaryAll = action.payload;
    },
    setWorkflowDictionary: (state, action) => {
      state.workflowDictionary = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setWorkflowDictionaryAll,
  setWorkflowDictionary,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = workflowDictionarySlice.actions;

export default workflowDictionarySlice.reducer;
